// extracted by mini-css-extract-plugin
export default {"page":"page-tMDU7","body":"body-FVqrr","footer":"footer-NmmRq","navigation":"navigation-pu2po","backBtn":"backBtn-STscs"};